import type { FaireProductEntity } from "../../entity_types/product";

export const p_tpf2apke3k: FaireProductEntity = {
  token: "p_tpf2apke3k",
  type: "product",
  name: "Vintage Gold Oval Bracelet Quartz Watch DP25F736",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/c78feaa25dd3c4def07ed0e6c673908226373798dba7cba7a399e28b7c027f86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d80624d68923f72d347a7d8f23f9d2ae74352acafa9f2e4883211e33ebbec83a.jpeg",
    "https://cdn.faire.com/fastly/adeb5ad87c664c8ccd48af381b15186f8791f28317183b7250aa499c869bb409.jpeg",
    "https://cdn.faire.com/fastly/6fc5fe0996d220328e911d55e13db2a3b69e45db2c767b8ce22b074f7d6fdd41.jpeg",
    "https://cdn.faire.com/fastly/6081c93986eb7e79a3fea2b86e9c829b43e4c6999036959137ed96b74c2e2cea.jpeg",
    "https://cdn.faire.com/fastly/1bcea1821f28a5fec777500cbccb10e01ed445ab08f9da76f1e1e3748eb2a0e5.jpeg",
    "https://cdn.faire.com/fastly/f2df3060fd5d6c66067d893398f17339845b609374d31e1eeb22615c99824e04.jpeg",
    "https://cdn.faire.com/fastly/e087a24209f1502e4bfc547b5de0ff261f910dd8f39bf7993378c83348fd0dec.jpeg",
    "https://cdn.faire.com/fastly/6c34ee85c76e2f6348a64a99d9504a4bf5f035e55a7d08bf7fa422a05101a516.jpeg",
    "https://cdn.faire.com/fastly/4edccbe462020d01d6831bb1347a802a42be7f1d4ea3dbb0062c5a3263d5892e.jpeg",
    "https://cdn.faire.com/fastly/d49c9282c26aacac478af8534a8ff866e83275c3dcbd8ebb9a77d1c8ff47c25f.jpeg",
    "https://cdn.faire.com/fastly/5c993f891140e80910a9ef12ef8d4729daa7047643e2fa37511b30f7fd39736f.jpeg",
  ],
  priceDollars: 7.59,
  description:
    "Feature:\n * Elegant, Vintage\n * Oval Dial\n * Blue Mother-of-Pearl DialDial\n * Flat-top Cone Crown\n * Quartz Movement\n * Standard Glass Crystal\n * No Water Resistan\n * Adjustable Strap \n * Stainless Steel Bracelet\n * Durable Case\n * Perfect Gift\n * Daily/ Business Fitting\n * Casual Style\n\n Material:\n * Metal\n\n Weigh: * 50g\n\n Package:\n * Package include 1 watch.\n\n * Avoid strong impacts or drops to prevent damage to the movement or glass. For leather straps: avoid direct contact with water, perfume to prevent discoloration or hardening.\n * Water resistance is limited. Do not wear the watch while swimming, showering, or exposing it to hot water.\n * Color may slightly vary due to lighting and monitor differences. Store the watch in a cool, dry place when not in use.\n * Product includes watch only (no extra jewelry/props included).",
  tags: [],
  msrpDollars: 15.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:15.456Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
